import { render } from "./CreateEventComponent.vue?vue&type=template&id=2107f969&scoped=true"
import script from "./CreateEventComponent.vue?vue&type=script&lang=js"
export * from "./CreateEventComponent.vue?vue&type=script&lang=js"

import "./CreateEventComponent.vue?vue&type=style&index=0&id=2107f969&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2107f969"]])

export default __exports__